import { Component } from '@angular/core';
import {  NavController, NavParams, LoadingController } from 'ionic-angular';
import { Http } from '@angular/http';
import { ModalController } from 'ionic-angular';
import { AlertController } from 'ionic-angular';

import { HomePage } from "../home/home";
import config from '../../config/config';

@Component({
  selector: 'page-list',
  templateUrl: 'list.html'
})
export class ListPage {
projetos=null;

  constructor(    public navCtrl: NavController,
     public navParams: NavParams,
     public loadingCtrl: LoadingController,
    public _http: Http,
    private alertCtrl: AlertController,
    public modalCtrl : ModalController) {
}

 ngOnInit(){
    this.getProjetos();
    // this.getProdutos();
    // this.getItems();

  }

     getProjetos() {
        let loader = this.loadingCtrl.create({
        content:"Carregando informações! Aguarde..."
      });
      loader.present();
      this._http
      .get(config.urla+"/projeto/listar")
      .map(res =>res.json())
      .toPromise() 
      .then(res => {
        loader.dismiss();
        this.projetos=res;
       
      })
      .catch(err=>{
        loader.dismiss();
        let alert = this.alertCtrl.create({
            title: 'um erro encontrado',
            message: 'sua pagina não pode ser carregada!!',
            cssClass: 'alertCustomCss',
            buttons: [
              {
                text: 'Ok',
                role: 'OK',
                handler: () => {
                  this.navCtrl.push(HomePage);
                }
              },
            ]
          });
  alert.present();

        
      })
  }
}



// WEBPACK FOOTER //
// ./src/pages/list/list.ts